const isLoggedIn = user => !!(user && user.user && user.user._id);

export default isLoggedIn;
